import moment from 'moment';
import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Calendar } from '../UI/calendar';
import { X } from 'lucide-react';

type DateCellProps = {
  row: any;
  debouncedSearch: any;
  highlightText: (text: any, searchTerm: any, delay?: number) => any;
  date: any;
  dateKey: string;
  handleChangeDate(obj: any, field: string, v: Date | undefined): void;
  disabled?: boolean;
};

const DateCell = (props: DateCellProps) => {
  const { row, debouncedSearch, highlightText, date, dateKey, handleChangeDate, disabled = false } = props;

  const date_format = !date
    ? undefined
    : moment(date).isValid()
      ? moment(date).toDate()
      : undefined;

  return (
    <Popover>
      <PopoverTrigger
        data-qa={`projects_row_${row?.original?.id}_project_${dateKey}_date_trigger`}
        asChild
      >
        <div className="group/date flex justify-center items-center gap-1">
          <button
            type="button"
            disabled={disabled}
            className="hover:text-teal transition disabled:cursor-not-allowed disabled:opacity-60"
          >
            {highlightText(
              date_format ? moment(date_format).format('MM/DD/YY') : 'MM/DD/YY',
              debouncedSearch
            )}
          </button>

          {row?.original?.[dateKey] && (
            <button
              disabled={disabled}
              onMouseDown={(e) => {
                if (disabled) return;
                e.preventDefault();
                e.stopPropagation();
                handleChangeDate(row?.original, dateKey, undefined);
              }}
              data-qa={`projects_row_${row?.original?.id}_date_clear_trigger`}
              className="h-3.5 w-3.5 rounded text-muted-foreground opacity-0 transition-opacity group-hover/date:opacity-100 hover:bg-muted hover:text-foreground hover:[&_svg]:text-destructive"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </div>
      </PopoverTrigger>
      <PopoverContent className="z-[1000] rounded-md border border-input bg-popover text-popover-foreground shadow-md outline-none pointer-events-auto data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 w-auto p-0">
        <Calendar
          data-qa={`projects_row_${row?.original?.id}_project_${dateKey}_date_calendar`}
          selected={date_format}
          mode="single"
          className="rounded-md border-0 p-[12px]"
          onSelect={(v) => {
            if (disabled) return;
            handleChangeDate(row?.original, dateKey, v);
          }}
        />
      </PopoverContent>
    </Popover>
  );
};

export default DateCell;
